import React from "react";
import { useTranslation } from "react-i18next";
import { Calendar, CalendarProps } from "primereact/calendar";
import { addLocale } from "primereact/api";
import { Info } from "luxon";

export function InternationalDatepicker(props: CalendarProps) {
  const { t, i18n } = useTranslation();

  addLocale("current", {
    firstDayOfWeek: 1,
    dayNames: [
      t("common.sunday"),
      t("common.monday"),
      t("common.tuesday"),
      t("common.wednesday"),
      t("common.thursday"),
      t("common.friday"),
      t("common.saturday"),
    ],
    dayNamesShort: [
      t("common.sundayShort"),
      t("common.mondayShort"),
      t("common.tuesdayShort"),
      t("common.wednesdayShort"),
      t("common.thursdayShort"),
      t("common.fridayShort"),
      t("common.saturdayShort"),
    ],
    dayNamesMin: [
      t("common.sundayShort"),
      t("common.mondayShort"),
      t("common.tuesdayShort"),
      t("common.wednesdayShort"),
      t("common.thursdayShort"),
      t("common.fridayShort"),
      t("common.saturdayShort"),
    ],
    monthNames: Info.months("long", { locale: i18n.language }),
    monthNamesShort: Info.months("short", { locale: i18n.language }),
  });

  return (
    <React.Fragment>
      <Calendar locale="current" dateFormat="dd-MM-yy" placeholder={t("common.selectDate")} {...props} />
    </React.Fragment>
  );
}
